module.exports = __webpack_public_path__ + "static/19-2cab227b1493a2bad47e2601c0a5186c.png";